import React from 'react';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import AuthorizedAction from '../../../AuthorizedAction.js';

const LinkedFileCard = ({
  name,
  url,
  owner,
  created_at,
  group_roles,
  showAccess,
}) => {
  const renderGroupRoles = () => {
    return (
      <AuthorizedAction action="read" subject="linkedFile">
        <div className="flex flex-col flex-align-start">
          {group_roles.map((groupRole, index) => (
            <p key={index} className="m-0" style={{ margin: '5px' }}>
              <span className="text-capitalize">
                {groupRole === 'viewer' ? 'group viewer' : 'Change Advocate'}
              </span>
            </p>
          ))}

          {group_roles.length <= 0 ? '—' : null}
        </div>
      </AuthorizedAction>
    );
  };

  return (
    <Row
      className="flex flex-align-center"
      style={{ padding: '10px 14px', borderBottom: '1px solid #DFE2E5' }}
    >
      <Col xs={showAccess ? 4 : 5}>
        <a href={url} target="_blank" rel="noreferrer">
          {name}
        </a>
      </Col>
      <Col
        xs={showAccess ? 3 : 4}
        className={owner.archived ? 'text-muted' : ''}
      >
        {owner.name}
      </Col>
      {showAccess ? (
        <Col xs="3" className={owner.archived ? 'text-muted' : ''}>
          {group_roles ? renderGroupRoles(group_roles) : '—'}
        </Col>
      ) : null}
      <Col xs={showAccess ? 2 : 3}>{moment(created_at).format('MM/DD/YY')}</Col>
    </Row>
  );
};

export default LinkedFileCard;
